import { render } from "./ReferenceComponent.vue?vue&type=template&id=ede3e9a4&scoped=true"
import script from "./ReferenceComponent.vue?vue&type=script&lang=js"
export * from "./ReferenceComponent.vue?vue&type=script&lang=js"

import "./ReferenceComponent.vue?vue&type=style&index=0&id=ede3e9a4&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ede3e9a4"]])

export default __exports__